export const filterButtonBase =
  'w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors duration-150';

export const filterButtonSelected =
  'bg-indigo-50 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800';

export const filterButtonDefault =
  'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600';

export const countBadgeDefault =
  'text-xs px-1.5 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400';

export const countBadgeSelected =
  'text-xs px-1.5 py-0.5 rounded-full bg-indigo-200 dark:bg-indigo-800 text-indigo-700 dark:text-indigo-300';
